var fourToldApp = angular.module("fourToldApp", ["config","angularjs-crypto", "ngRoute", "ngMaterial", "ngAutocomplete", "ngSanitize", "webcam", "fourToldServices", "rw.moneymask", "ngStorage", "ngAnimate", "ngStorage", "ui.bootstrap", "ngCookies", "ui.bootstrap.typeahead", "angularModalService", "angular-toArrayFilter", "ngMessages", "angular-storage", "ngIdle", "satellizer", "ngFileUpload", "luegg.directives", "ui.utils.masks"]);
fourToldApp.config(['$locationProvider','$routeProvider', '$httpProvider', '$injector', '$sceDelegateProvider', '$authProvider', '$mdThemingProvider', 'IdleProvider', '$mdIconProvider', '$mdDateLocaleProvider', function($locationProvider, $routeProvider, $httpProvider) {
    $locationProvider.hashPrefix('');

$routeProvider.when("/", {
    templateUrl: "views/pages/login.html",
    controller: "loginCntrl",
    resolve: {
        data: function(DataResolver, $location) {
            if(!$location.search().land)
                return DataResolver();
        },
        check: function($location, $rootScope, $window, $q) {
            if ($location.search().user_teller_agent) {
                $window.sessionStorage.setItem('user_teller_agent', $location.search().user_teller_agent);
            } else {
                $window.sessionStorage.removeItem("user_teller_agent");
            }
            if ($location.search().land === 'reg' && $window.localStorage.getItem('access_token1') == null)
                return $q.reject($location.path('/terms'));
            else if($window.localStorage.getItem('access_token1') !== null){
                $rootScope.loggedIn = true;
                return $q.reject($location.path('/dashboard'));
            }
            else{
                for (var prop in $rootScope) {
                    if (prop.substring(0,1) !== '$') {
                        delete $rootScope[prop];
                    }
                }
                return $q.when();
            }
        }
    }
    }).when("/change-password", {
        templateUrl: "views/pages/change-password.html",
        controller: "changepasswordCntrl",
        resolve:{
          check: function($location, $rootScope, $window){
            if ($window.localStorage.getItem('access_token1') == null) {
                $location.path('/');
            } else {
                $rootScope.loggedIn = true;
            }
          }
        }
    }).when("/change-password-section", {
        templateUrl: "views/pages/change-password-section.html",
        controller: "changepasswordCntrl",
        resolve:{
          check: function($location, $rootScope, $window){
            if ($window.localStorage.getItem('access_token1') == null) {
                $location.path('/');
            } else {
                $rootScope.loggedIn = true;
            }
          }
        }
    }).when("/forgot-password", {
        templateUrl: "views/pages/forgot-password.html",
        controller: "recoverPasswordCntrl",
        resolve:{
          check: function($location, $rootScope, $window){
            if($window.localStorage.getItem('access_token1') !== null){
                $rootScope.loggedIn = true;
                $location.path('/dashboard');
            }
          }
        }
    }).when("/delete-user", {
        templateUrl: "views/pages/delete-user.html",
        controller: "deleteuserCntrl",
    }).when("/register", {
        templateUrl: "views/pages/register.html",
        controller: "registerCntrl",
        resolve: {
            data: function(DataResolver) {
                return DataResolver();
            },
            check: function($location, $rootScope, $window, $q) {
                if ($location.search().user_teller_agent) {
                    $window.sessionStorage.setItem('user_teller_agent', $location.search().user_teller_agent);
                } else {
                    $window.sessionStorage.removeItem("user_teller_agent");
                }
            }
            ,
            validate: ["$q", "$routeParams", "$localStorage", "$window", "$location", "$rootScope", function($q, $routeParams, $localStorage, $window, $location, $rootScope) {
                let istoken = $window.localStorage.getItem('access_token1') === null ? false : true;
                switch(istoken) {
                    case true:
                        if(($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                            && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb')))){
                                return $q.when();
                        }else{
                            $rootScope.loggedIn = true;
                            return $q.reject($location.path('/dashboard'));
                        }
                      break;
                    case false:
                        if (performance.navigation.type !== 1) {
                            $localStorage.register = $routeParams.register || ($location.search().offline  || ($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                            && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb')))) ? true : false;
                        }
                        if ($localStorage.register && $localStorage.register === true) {
                            return $q.when();
                        } else return $q.reject($location.path('/'));
                      break;
                    default:
                      // code block
                  }
            }]
        }
    }).when("/terms", {
        templateUrl: "views/pages/termsConditions.html",
        controller: "termsCntrl",
        resolve: {
            data: function(DataResolver, $location) {
                if($location.search().land)
                    return DataResolver();
            },
            check: function($location, $rootScope, $window, $q) {
                if($window.localStorage.getItem('access_token1') !== null){
                    $rootScope.loggedIn = true;
                    return $q.reject($location.path('/dashboard'));
                } 
                else if(!$window.sessionStorage.getItem("lang") && !$location.search().land)
                    return $q.reject($location.path('/'));
                else return $q.when();
            }
        }
    }).when("/verification-code", {
        templateUrl: "views/pages/token-verification.html",
        controller: "tokenVerificationCntrl",
        resolve: {
          check: function($location, $rootScope, $cookieStore, $localStorage, $window, $routeParams) {
            if (performance.navigation.type !== 1 && $window.localStorage.getItem('access_token1') == null) {
                if($routeParams.verification)
                  $localStorage.verification = true;
                else $localStorage.$reset();
            }           
          }
        }
    }).when("/verification", {
        templateUrl: "views/pages/verification_code.html",
        controller: "verificationCntrl",
        resolve: {
          check: function($location, $rootScope, $cookieStore, $localStorage, $window, $routeParams) {
            if (performance.navigation.type !== 1 && $window.localStorage.getItem('access_token1') == null) {
                if($routeParams.verification)
                  $localStorage.verification = true;
                else $localStorage.$reset();
            }
            if(!$localStorage.verification && $window.localStorage.getItem('access_token1') == null)
                $location.path('/');
            else if($window.localStorage.getItem('access_token1') !== null){
                $rootScope.loggedIn = true;
                $location.path('/dashboard');
            }
          }
        }
    }).when("/quentions", {
        templateUrl: "views/pages/questions.html",
        controller: "quentionsCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services, productService) {
                if (productService.getProducts().length === 0 && !$window.localStorage.getItem('access_token1')) {
                    $location.path('/');
                }
                else if($window.sessionStorage.getItem('needConfigureQuestions') === true){
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/dashboard", {
        templateUrl: "views/dashboard/home.html",
        controller: "init",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if (!$window.localStorage.getItem('access_token1')) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/profile", {
        templateUrl: "views/user/profile.html",
        controller: "userCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/groups", {
        templateUrl: "views/dashboard/groupList.html",
        controller: "groupListCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/groupDetails", {
        templateUrl: "views/dashboard/groupDetails.html",
        controller: "groupDetailsCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/loanList", {
        templateUrl: "views/dashboard/creditList.html",
        controller: "creditListCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/loanDetails", {
        templateUrl: "views/dashboard/creditDetails.html",
        controller: "creditDetailsCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/profile", {
        templateUrl: "views/dashboard/profile.html",
        controller: "profileCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/password-recovery", {
        templateUrl: "views/pages/password-recovery.html",
        controller: "passwordRecoveryCntrl",
        resolve:{
          
        }
    }).when("/groups", {
        templateUrl: "views/dashboard/groupList.html",
        controller: "groupListCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    }).when("/groupDetails", {
        templateUrl: "views/dashboard/groupDetails.html",
        controller: "groupDetailsCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }
    })
    .when("/viewform", {
        templateUrl: "views/dashboard/formView.html",
        controller: "formCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }

    })
    .when("/lifeproof", {
        templateUrl: "views/dashboard/lifeProof.html",
        controller: "lifeProofCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }

    })
    .when("/lifeproofNoModel", {
        templateUrl: "views/dashboard/lifeProof.html",
        controller: "lifeProofNoModelCntrl",
        resolve: {
            "check": function($location, $rootScope, $cookieStore, $window, $cookies, services) {
                if ($window.localStorage.getItem('access_token1') == null) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            }
        }

    })
    .when("/guarantor", {
        templateUrl: "views/dashboard/guarantors.html",
        controller: "guarantorCntrl",
        resolve: {
            "check": function($location, $rootScope, $window) {
                if ($window.localStorage.getItem('access_token1') == null)
                    $location.path('/');
                else
                    $rootScope.loggedIn = true;

            }
        }
    }).when("/channel/:item", { /*"/channel/:alternateChannel"*/
        templateUrl: "views/dashboard/channel.html",
        controller: "channelCntrl",
        resolve: {
            "check": function($location, $rootScope, $window) {
                if (!$window.localStorage.getItem('access_token1')) {
                    $location.path('/');
                } else {
                    $rootScope.loggedIn = true;
                }
            },
            alternateChannel: function ($route, $localStorage) { $route.current.params.alternateChannel = $localStorage.alternateChannel;},
            alternateChannelId: function ($route, $localStorage) { $route.current.params.alternateChannelId = $localStorage.alternateChannelId;}
        }
    }).when("/passwordform", {
        templateUrl: "views/pages/change-password-form.html",
        controller: "changePasswordFormCntrl",
        resolve:{
          check: function($location, $rootScope, $window){
            if ($window.localStorage.getItem('access_token1') == null) {
                $location.path('/');
            } else {
                $rootScope.loggedIn = true;
            }
          }
        }
    }).when("/managed-session", {
        templateUrl: "views/pages/managed-session.html",
        controller: "managedSessionCntrl"
    }).when("/rekognition", {
        templateUrl: "views/pages/rekognition.html",
        controller: "rekognitionCntrl"
    }).otherwise({
        redirectTo: "/"
    });

    //$httpProvider.interceptors.push(interceptor);
    $httpProvider.interceptors.push('APIKey');    
    $httpProvider.interceptors.push('preventTemplateCache');
    $httpProvider.interceptors.push('httpRequestInterceptor');
    //$httpProvider.interceptors.push('interceptorInternet');
    $httpProvider.interceptors.push('requestRecoverer');
    $httpProvider.interceptors.push('refresh_token');
}]);

fourToldApp.service('sharedService', function(){
    this.shared = null;
    this.data = null;
    return {
     setShared: function(val){this.shared = val;},
     getShared: function(){return this.shared;},
     setData: function(val){this.data = val;},
     getData: function(){return this.data;}
    }
});

fourToldApp.service('UserService', function(store) {
    var service = this,
        currentUser = null;

    service.setCurrentUser = function(user) {
        if (user !== null) {
            currentUser = user;
            store.set('user', user);
        }
        return currentUser;
    };
    service.getCurrentUser = function() {
        if (currentUser !== null) {
            currentUser = store.get('user');
        }
        return currentUser;
    };
});

fourToldApp.factory('APIKey', function($injector, APIKeyGooglePlaces) {
     var tag = document.createElement('script');
     window.initMaps = function(){};
     tag.src = "https://maps.googleapis.com/maps/api/js?libraries=places&key="+ APIKeyGooglePlaces+"&callback=initMaps";
     tag.async = true;
     tag.defer = true;
     var firstScriptTag = document.getElementsByTagName('script')[0];
     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
     return {}
  });


fourToldApp.factory('preventTemplateCache', function($injector, version) {
    return {
          'request': function(config) {
            if (config.url.indexOf('views') !== -1) {
              config.url = config.url + '?v=' + version;
            }
            return config;
          }
        }
 });

fourToldApp.service('interceptorInternet', function($rootScope, $q, $injector, $timeout) {
  return {
      responseError: function(response) {
          if (response.data == null && response.status === -1 && response.statusText === "") {
              //console.log("here interceptor2");
              var $http = $injector.get('$http');
              var deferred = $q.defer();
              $timeout(function() {
                  deferred.resolve(true);
              }, 1000);

              return deferred.promise.then(function() {
                  console.log("here interceptor");
                  return $http(response.config);
              });
          }
          return $q.reject(response);
      }
    }
});

fourToldApp.factory('favicon', function() {
    var link = document.querySelector("link[rel~='icon']");
    return {
      setIcon: function(icon) {
          if(icon)
            link.href = icon;
      }
    };
});

fourToldApp.factory('DataResolver', ['$q', 'services', '$window', '$location', '$rootScope', 'esb', 'favicon',
  
    function($q, services, $window , $location, $rootScope, esb, favicon){
      return function(){
        if (!$window.localStorage.getItem('access_token1')) {
          var result = $q.defer();
          if($location.search().tag !== undefined && $location.search().tag !== null){
            $window.sessionStorage.removeItem("theme");
            services.specificTag().theme({tag:$location.search().tag}, function(response) {
              switch(response.code) {
                  case 1:
                    if(response.data && response.data[0].field4 !== undefined){
                        $window.sessionStorage.setItem("theme",response.data[0].field4);
                        $rootScope.tag = $location.search().tag.toUpperCase();
                        favicon.setIcon(esb+"/security"+JSON.parse($window.sessionStorage.getItem("theme")).statusbar_icon);
                        let themeData = JSON.parse($window.sessionStorage.getItem("theme"));
                        $rootScope.title = themeData.app_name;
                        if (themeData.client_config){
                            for (const item of themeData.client_config) {
                                if (item.type === 'GOOGLE_TAG_MANAGER'){
                                    let script = document.createElement('script');
                                    script.textContent = item.params.find(p => p.key === "header").value;
                                    document.getElementsByTagName('head')[0].appendChild(script);
                                    console.log('appending gtm to head');

                                    let noscript = document.createElement('noscript');
                                    var nsiframe = document.createElement('iframe');
                                    nsiframe.src = item.params.find(p => p.key === "body").value;
                                    nsiframe.height = "0";
                                    nsiframe.width = "0";
                                    nsiframe.style = "display:none;visibility:hidden";
                                    noscript.appendChild(nsiframe);
                                    document.getElementsByTagName('body')[0].appendChild(noscript);
                                    console.log('appending gtm to body');
                                }
                            }
                        }
                        result.resolve(response);
                    }
                    break;
                  case -31:
                      favicon.setIcon("/images/icons/logo/favicon-32x32.png");
                      $rootScope.title = "Borrower Web";
                      result.resolve({});
                      break;
                  }
            }, function error(response) {console.log("error tag")});
          } else {
            $window.sessionStorage.removeItem("theme");
            favicon.setIcon("/images/icons/logo/favicon-32x32.png");
            $rootScope.title = "Borrower Web";
            result.resolve({});
          }
          return result.promise;
        }
      };
}]);

fourToldApp.factory('clearData', ['$q', '$timeout', 'services', '$window',  '$location', '$cookieStore', '$localStorage',
  function($q, $timeout, services, $window , $location, $cookieStore, $localStorage,){
      $window.localStorage.clear();
      $localStorage.$reset();
      return true;
}]);

fourToldApp.factory('productService', function() {
  var productList = [];
  var addProduct = function(newObj) {
      productList.push(newObj);
  };
  var getProducts = function(){
      return productList;
  };
  return {
    addProduct: addProduct,
    getProducts: getProducts
  };

});

fourToldApp.directive('simpleFocus', function ($timeout) {
  return {
    restrict: 'A',
    scope: {
      simpleFocus: '='
    },
    link: function(scope, element) {
      scope.$watch('simpleFocus', function() {
        $timeout(function() {
          var value = scope.simpleFocus;
          if(value === true || value === undefined) {
            element[0].focus();
            scope.simpleFocus = false;
          }
        });
      });
    }
  };
});

fourToldApp.factory('requestRecoverer', ['$q', function($q) {
    var token = 'bearer ';
    var requestRecoverer = {
        requestError: function(rejectReason) {
            if (rejectReason === 'requestRejector') {
                // Recover the request
                return {
                    transformRequest: [],
                    transformResponse: [],
                    method: 'POST',
                    url: 'http://4told-Stage-3071028.us-east-1.elb.amazonaws.com:8091/security/oauth/check_token',
                    params: {},
                    isArray: false,
                    headers: {
                        "Authorization": token
                    },
                    data: token
                };
            } else {
                return $q.reject(rejectReason);
            }
        }
    };
    return requestRecoverer;
}]);


function deleteAllCookies(){
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
};


fourToldApp.factory('session', function($window, $route, $templateCache, $rootScope, $location) {
   return {
     logout: function(register) {
        $templateCache.remove('signature.html');
        $templateCache.remove('loanList.html');
        $templateCache.remove('address.html');
        $templateCache.remove('security_questions.html');
        var phoneNumber = window.sessionStorage.getItem("phoneNumber");
        var prefix = window.sessionStorage.getItem("prefix");
        var phoneNumberDeleted = $window.localStorage.getItem("phoneNumberDeleted");
        var usernameSupport = $window.localStorage.getItem("usernameSupport");
        var agentMode = window.sessionStorage.getItem('mode') == 'asesorweb' ? true : false;
        var loginType = window.sessionStorage.getItem('loginType');
        var t_agent = window.sessionStorage.getItem('t_agent');

        var dt = window.sessionStorage.getItem("documentType");
        var lwi = window.sessionStorage.getItem("loginWithID");

        deleteAllCookies();
        $window.localStorage.clear();
        const theme = $window.sessionStorage.getItem("theme");
        $window.sessionStorage.clear();
        $window.sessionStorage.setItem("theme", theme);
        if(dt != null && lwi != null) {                
            window.sessionStorage.setItem("documentType", dt);
            window.sessionStorage.setItem("loginWithID", lwi);
        }
        window.top.postMessage('logout', '*');
        if(phoneNumber)
            window.sessionStorage.setItem('phoneNumber', phoneNumber);
        if(prefix) 
            window.sessionStorage.setItem("prefix", prefix);
        if(phoneNumberDeleted) 
            $window.localStorage.setItem("phoneNumberDeleted", phoneNumberDeleted);
        if(usernameSupport) 
            $window.localStorage.setItem("usernameSupport", usernameSupport);
        if(agentMode)
            window.sessionStorage.setItem('mode', 'asesorweb');
        if(loginType)
            window.sessionStorage.setItem('loginType', loginType);
        if(t_agent)
            window.sessionStorage.setItem('t_agent', t_agent);    
        delete $rootScope.scrollBottom;
        $rootScope = $rootScope.$new(true);
        $("#main-content").removeClass('content-all');
        $('#main-content').removeClass('merge-left');
        if ($location.search()._managed == '2'){
            if ($window.localStorage.getItem("retry") != 'true'){ // this is set to retry xmpp connection
                $window.localStorage.setItem("logout", 'true'); // tells managed-session a logout has been triggered
                $location.path("/managed-session");
            }
        } else {
            if(!register){
                $location.path('/');
                $rootScope.$apply();
            }
        }
     }
   };
});
function removeParam(key, sourceURL) {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
};
fourToldApp.config(['KeepaliveProvider', 'IdleProvider', 'TitleProvider',  function(KeepaliveProvider, IdleProvider, TitleProvider) {
    TitleProvider.enabled(false);
    IdleProvider.idle(5 * 60); // 5 minutes idle    
    IdleProvider.timeout(15); 
    KeepaliveProvider.interval(1 * 60); 
}]);

fourToldApp.run(['templates', '$rootScope', '$cookieStore', 'xmppAuth', '$window', '$location', '$timeout', 'cryptool', '$localStorage', 'session', 'services', function(templates, $rootScope, $cookieStore, xmppAuth, $window, $location, $timeout, cryptool, $localStorage, session, services) {
    $rootScope.online = navigator.onLine;
    $window.addEventListener('message', function (e) {
        console.log('e.data === "logout"' + $window.localStorage.getItem("access_token1"))
        if(e.data === "logout" && $window.localStorage.getItem("access_token1")){           
            var token = $window.localStorage.getItem("access_token1");
            $window.localStorage.removeItem("access_token1");
            services.logout("bearer " + token).post({}, {}, function (response) {
                xmppAuth.Chat.connectionStatus = 0;
                xmppAuth.Chat.disconnect();
                window.top.postMessage('success-logout', '*')
                console.log('logout')
            });
        } else if(e.data === "logout") window.top.postMessage('success-logout', '*')
    });
    $window.addEventListener("offline", function() {
    $rootScope.$apply(function() {
        $rootScope.online = false;
    });
    }, false);
    $window.addEventListener("online", function() {
    $rootScope.$apply(function() {
        $rootScope.online = true;
    });
    }, false);
    $timeout(function() {
        if($location.search().agentTData){
            window.sessionStorage.setItem('t_agent', JSON.stringify($location.search().agentTData));
            const newUrl = removeParam('agentTData', window.location.href);
            window.location.replace(newUrl);
        }
        if($location.search().mode){
            window.sessionStorage.setItem('mode', $location.search().mode);
        }
    }, 0);
    $rootScope.$on('$routeChangeStart', function (event, next, current) {
        if($window.sessionStorage.getItem("userXmpp") == null && $window.localStorage.getItem('access_token1') !== null){
          $cookieStore.remove('access_token');
          $window.localStorage.removeItem('access_token1');
          console.log("cambiando ruta")
          //session.logout();            
        }
        else if (!current && xmppAuth.Chat.connection == null) {
            if($localStorage.jid && $window.localStorage.getItem('access_token1') !== null){
              $rootScope.reload = true;
              $cookieStore.put('reload', "true");
              $cookieStore.put('isConnected', "data");
              templates.template();
              xmppAuth.Chat.connect($window.sessionStorage.getItem("userXmpp")+"@"+cryptool.decryptData($window.sessionStorage.getItem("serviceName")),cryptool.decryptData($window.sessionStorage.getItem("passwordXmpp")));
            }
          }
      });
}]);

fourToldApp.service('httpRequestInterceptor', function($q, $window) {
    return {
        request: function(config) {
            var access_token = null;
            //if ($cookieStore.get('access_token') !== undefined)
            if ($window.localStorage.getItem('access_token1') !== null)
                access_token = 'bearer ' + $window.localStorage.getItem('access_token1');

            if (access_token !== null && !config.headers.Authorization) {
                config.headers.Authorization = access_token;
            }
            return config;
        },
        responseError: function(response) {
            return $q.reject(response);
        }
    };
});

fourToldApp.service('refresh_token', function($q, $window) {
    return {
        request: function(config) {
            var token = null;
            var deferred = $q.defer();

            if ($window.localStorage.getItem('access_token1') !== null)
                token = 'bearer ' + $window.localStorage.getItem('access_token1');
            return config;
        }
    };
});

fourToldApp.directive('scrollToBottom', function($timeout) {
    return {
        scope: {
            scrollToBottom: "="
        },
        restrict: 'A',
        link: function(scope, element, attr) {
            scope.$watchCollection('scrollToBottom', function(newVal) {
                if (newVal) {
                    $timeout(function() {
                        element[0].scrollTop =  element[0].scrollHeight;
                    }, 0);
                }

            });
        }
    };
});

fourToldApp.filter('counter', [function() {
    return function(seconds) {
        return new Date(1970, 0, 1).setSeconds(seconds);
    };
}]);

fourToldApp.filter('addTargetBlank', function(){
  return function(x) {
    var tree = angular.element('<div>'+x+'</div>');//defensively wrap in a div to avoid 'invalid html' exception
    tree.find('a').attr('target', '_blank'); //manipulate the parse tree
    return angular.element('<div>').append(tree).html(); //trick to have a string representation
  }
});

fourToldApp.directive('readonly',function(){
   return {
    restrict: 'EAC',
    link: function(scope, elem, attr) {
      document.querySelectorAll("#datePicker input")[0].setAttribute("readonly","readonly");
       angular.element(".md-datepicker-button").each(function(){
            var el = this;
            var ip = angular.element(el).parent().find("input").bind('click', function(e){
                angular.element(el).click();
            });
            angular.element(this).css('visibility', 'hidden');
        });
    }
   }
});

fourToldApp.directive('chatMessageList', function() {
	return {
		scope: {
			list: '=chatMessageList'
		},
		link: function(scope, element) {
			scope.$watchCollection('list', function(newVal) {
        if (newVal) {
          var $list = $(element).find('.js-chat-list');
  				var scrollHeight =  element[0].scrollHeight;
  				$list.animate({scrollTop: scrollHeight}, 1000);
        }
			});
		}
	};
});

fourToldApp.filter('search', function () {
    return function (input, text) {
        if (!angular.isString(text)) {
          return input;
        }
        return input.filter(function (item) {
            if(item.value === item.value.toUpperCase())
                text = text.toUpperCase();
            if(item.value === item.value.toLowerCase())
                text = text.toLowerCase();
            if(item.value === item.value.charAt(0).toUpperCase() + item.value.slice(1))
                text = text.charAt(0).toUpperCase() + text.slice(1);
            return (item.value.indexOf(text) > -1);
        });
    };
});

fourToldApp.directive('emptyToDefault', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          defaultValue: '='
        },
        link: function (scope, elem, attrs, ctrl) {
            ctrl.$parsers.push(function(viewValue) {
                if(viewValue === "")
                    viewValue = null;
                return viewValue;
            });
        }
    };
});

fourToldApp.factory('localstorage', ['$window', function($window) {
    return {
    set: function(key, value) {
    $window.localStorage[key] = value;
    },
    remove: function(key) {
    $window.localStorage.removeItem(key);
    },
    get: function(key, defaultValue) {
    return $window.localStorage[key] || defaultValue;
    },
    setObject: function(key, value) {
    $window.localStorage[key] = JSON.stringify(value);
    },
    getObject: function(key) {
    return JSON.parse($window.localStorage[key] || '{}');
    },
    clearAll: function() {
     $window.localStorage.clear();
    }
    }
}]);
fourToldApp.config(function($mdThemingProvider) {
    $mdThemingProvider.theme('custom-toast')
});
